import { render, staticRenderFns } from "./ProportionAnalysis.vue?vue&type=template&id=dd523f30&scoped=true"
import script from "./ProportionAnalysis.vue?vue&type=script&lang=js"
export * from "./ProportionAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProportionAnalysis.vue?vue&type=style&index=0&id=dd523f30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd523f30",
  null
  
)

export default component.exports